import React, { ReactElement } from 'react';

import { CellTypeNames } from '../../../../../../common/table/CellTypeConstants';
import { CellTypeFormatChanges, CellTypeObjectWithAuto } from '../../../../../../common/table/TableTypes';
import { Sheet } from '../../../../../mobile/structural/sheet/Sheet';
import { UseSheetReturnType } from '../../../../../mobile/structural/sheet/hooks/useSheet';
import CellTypeFormatContent from '../../../../../element/table/cellTypes/CellTypeFormatContent';

import './MobileCellTypeFormatSheet.scss';

type Props = {
    sheetProps: UseSheetReturnType;
    currentCellType: CellTypeNames;
    sharedCellTypeFormatOptions: CellTypeObjectWithAuto;
    locale: string;
    updateCellTypeFormat: (cellTypeFormatChanges: CellTypeFormatChanges) => void;
};

const MobileCellTypeFormatSheet = (props: Props): ReactElement => {
    const { sheetProps, ...formattingOptionsProps } = props;

    return (
        <Sheet className="MobileCellTypeFormatSheet" {...sheetProps}>
            <Sheet.Overlay />
            <Sheet.Panel>
                <Sheet.Content>
                    <div className="MobileCellTypeFormatSheetPopup" data-table-util>
                        <CellTypeFormatContent {...formattingOptionsProps} formSize="md" />
                    </div>
                </Sheet.Content>
            </Sheet.Panel>
        </Sheet>
    );
};

export default MobileCellTypeFormatSheet;
